import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Pagination } from 'antd';
import FaIcon from '../global/fa-icon/fa-icon';
import './_custom-data-table.scss';


const _emptyPageData = {
  activePageIdx: 0,
  numItems: 0,
  numTotalPages: 0,
  numTotalItems: 0,
  maxItemsPerPage: 10,
  firstPageIdx: 0,
  lastPageIdx: 0,
  pageDisplayOffset: 1,
};

const _emptySortData = {
  field: null,
  direction: 'asc'      // expects: 'asc' or 'desc'
};

class CustomDataTable extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
    title: PropTypes.any,
    showAddButton: PropTypes.bool,
    showSearch: PropTypes.bool,
    showSort: PropTypes.bool,
    showPaging: PropTypes.bool,
    showRowHeaders: PropTypes.bool,
    showStrippedRows: PropTypes.bool,
    showRowBorders: PropTypes.bool,
    showColBorders: PropTypes.bool,
    headers: PropTypes.array,
    rowRenderer: PropTypes.func,
    addonActions: PropTypes.node,
    addButtonType: PropTypes.string,
    addButtonSize: PropTypes.string,
    addButtonIcon: PropTypes.any,
    addButtonLabel: PropTypes.any,
    searchLabel: PropTypes.string,
    searchPlaceholder: PropTypes.string,
    searchText: PropTypes.string,
    sortData: PropTypes.object,
    pageData: PropTypes.object,
    paginationSize: PropTypes.string,
    paginationSimpleMode: PropTypes.bool,
    data: PropTypes.array,
    onSearchChanged: PropTypes.func,
    onSortChanged: PropTypes.func,
    onPageChanged: PropTypes.func,
    onRowClicked: PropTypes.func,
    onAddClicked: PropTypes.func,
  };

  static defaultProps = {
    title: null,
    showAddButton: false,
    showSearch: true,
    showSort: true,
    showPaging: true,
    showRowHeaders: true,
    showStrippedRows: true,
    showRowBorders: false,
    showColBorders: false,
    headers: null,
    rowRenderer: null,
    addonActions: null,
    addButtonType: 'primary',
    addButtonSize: 'large',
    addButtonIcon: <FaIcon icon="fa-plus" />,
    addButtonLabel: 'Add',
    searchIcon: <FaIcon icon="fa-search" />,
    searchLabel: 'Search',
    searchPlaceholder: 'Search',
    searchText: null,
    sortData: null,
    pageData: null,
    paginationSize: 'default',
    paginationSimpleMode: false,
    data: null,
    onSearchChanged: null,
    onSortChanged: null,
    onPageChanged: null,
    onRowClicked: null,
    onAddClicked: null
  };

  static get EmptyPageData() {
    return _.cloneDeep(_emptyPageData);
  }

  static get EmptySortData() {
    return _.cloneDeep(_emptySortData);
  }

  constructor(props) {
    super(props);

    /* let rowRenderer = this.props.rowRenderer;
    if (!rowRenderer || !_.isFunction(rowRenderer)) {
      rowRenderer = this.renderDefaultRowItemRenderer.bind(this);
    } */

    this._onSearchInputChanged = this._onSearchInputChanged.bind(this);
    this._onCurrentPageChanged = this._onCurrentPageChanged.bind(this);
    this._onPageLinkClicked = this._onPageLinkClicked.bind(this);

    let pageData = this.props.pageData || this.constructor.EmptyPageData;

    this.state = {
      // rowRenderer,
      searchTextValue: this.props.searchText,
      pageData,
    };

    this.invalidatePropsState();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.invalidatePropsState();
    if (!_.isEqual(this.props.pageData, prevProps.pageData)) {
      this.setState({ pageData: this.props.pageData });
    }
  }

  invalidatePropsState() {
    this.isRowClickable = !!_.isFunction(this.props.onRowClicked);
  }

  _onRowClicked(item) {
    if (this.props.onRowClicked) {
      this.props.onRowClicked(item);
    }
  }

  _onAddButtonClicked(e) {
    if (this.props.onAddClicked) {
      this.props.onAddClicked();
    }
  }

  _onSearchInputChanged(e) {

    let searchTextValue = _.get(e, 'target.value') || '';

    if (this.state.searchTextValue !== searchTextValue) {
      this.setState({ searchTextValue });

      if (this.props.onSearchChanged) {
        this.props.onSearchChanged(searchTextValue);
      }
    }
  }

  _onCurrentPageChanged(newPageNum) {
    let newPageIdx = Math.max(newPageNum - 1, 0);
    if (this.state.pageData.activePageIdx !== newPageIdx) {

      let pageData = _.cloneDeep(this.state.pageData);
      pageData.activePageIdx = newPageIdx;

      this.setState({ pageData });

      if (this.props.onPageChanged) {
        this.props.onPageChanged(pageData);
      }
    }
  }

  // TODO: joe- remove
  _onPageLinkClicked(newPageIdx) {
    // console.log('_onPageLinkClicked', newPageIdx);

    if (this.state.pageData.activePageIdx !== newPageIdx) {

      let pageData = _.cloneDeep(this.state.pageData);
      pageData.activePageIdx = newPageIdx;

      this.setState({ pageData });

      if (this.props.onPageChanged) {
        this.props.onPageChanged(pageData);
      }
    }
  }


  render() {
    let tableClasses = [];
    if (this.props.showStrippedRows) {
      tableClasses.push('cdt-striped-rows');
    }
    if (this.props.showRowBorders) {
      tableClasses.push('cdt-row-borders');
    }
    if (this.props.showColBorders) {
      tableClasses.push('cdt-col-borders');
    }
    if (this.props.showAddButton) {
      tableClasses.push('cdt-add-button');
    }
    if (this.props.showSearch) {
      tableClasses.push('cdt-search');
    }
    if (this.props.showSort) {
      tableClasses.push('cdt-sort');
    }
    if (this.props.showPaging) {
      tableClasses.push('cdt-paging');
    }
    tableClasses = _.join(tableClasses, ' ');
    if (tableClasses) { tableClasses = ' ' + tableClasses; }

    return (
      <div className={'cdt-custom-data-table cdt-table-main' + tableClasses}>
        { this.renderTableHeader() }
        { this.renderTableBody() }
        { this.renderTableFooter() }
      </div>
    );
  }

  renderTableHeader() {
    return (
      <div className="cdt-table-header d-flex flex-row flex-fill justify-space-between">
        <div className="d-flex flex-row flex-fill justify-content-start">
          { this.props.title? this.renderTableTitleArea(): null }
        </div>
        <div className="cdt-actions-area d-flex flex-row justify-content-end">
          { this.props.addonActions? this.renderAddonActionsArea(): null }
          { this.props.showAddButton? this.renderAddButtonArea(): null }
          { this.props.showSearch? this.renderTableSearchArea(): null }
        </div>
      </div>
    );
  }

  renderTableTitleArea() {
    let title = this.props.title || null;

    return (
      <div className="cdt-title-area">
        {title}
      </div>
    );
  }

  renderAddonActionsArea() {
    let addonActions = this.props.addonActions || null;

    return (
      <div className="cdt-addon-actions">
        {addonActions}
      </div>
    );
  }

  renderAddButtonArea() {
    let type = this.props.addButtonType || null;
    let size = this.props.addButtonSize || null;
    let icon = this.props.addButtonIcon || null;
    let label = this.props.addButtonLabel || null;

    return (
      <div className="cdt-add-button-area">
        <Button type={type} size={size} icon={icon} onClick={() => this._onAddButtonClicked()}>{label}</Button>
      </div>
    );
  }

  renderTableSearchArea() {
    let icon = this.props.searchIcon;
    let label = this.props.searchLabel;
    let placeholder = this.props.searchPlaceholder;
    let value = this.state.searchTextValue || undefined;

    return (
      <div className="cdt-search-area">
        <label>
          { label }
        </label>
        <Input.Search className='cdt-search-input'
               type='search'
               icon={icon}
               value={value}
               placeholder={placeholder}
               onChange={this._onSearchInputChanged}
          />
      </div>
    );
  }

  renderTableFooter() {
    return (
      <div className="cdt-table-footer">
        { (this.props.showPaging)? this.renderTablePagingArea(): null }
      </div>
    );
  }

  renderTablePagingArea() {
    let pageData = this.state.pageData;
    if (!pageData || pageData.numTotalItems <= 0) {
      return null;
    }

    return (
      <div className="cdt-paging-area">
        <Pagination size={this.props.paginationSize}
                    simple={this.props.paginationSimpleMode}
                    defaultCurrent={1}
                    current={pageData.activePageIdx + 1}
                    pageSize={pageData.maxItemsPerPage}
                    total={pageData.numTotalItems}
                    onChange={this._onCurrentPageChanged} />
      </div>
    );
  }

  renderTableBody() {
    let colHeaders = this.getColumnHeaders();

    return (
      <table className="cdt-table-body">
        { this.renderTableRowHeaders(colHeaders) }
        { this.renderTableRows(colHeaders) }
      </table>
    );
  }

  renderTableRowHeaders(colHeaders) {

    if (!this.props.showRowHeaders) { return null; }

    return (
      <thead className="cdt-table-row-headers">
        <tr className={'cdt-table-row-header cdt-table-row cdt-row-H'}>
          { _.map(colHeaders, (col, colIdx) => {
              let labelVal = _.get(col, 'label', _.get(col, 'field', null));
              return (
                <th className={'cdt-table-col cdt-col-' + colIdx} key={'cdt-col-' + colIdx}>
                  { labelVal }
                </th>
              );
            })
          }
        </tr>
      </thead>
    );
  }


  renderTableRows(colHeaders) {
    let rows = this.props.data;
    return (
      <tbody className="cdt-table-rows">
        { _.map(rows, (row, rowIdx) => { return this.renderTableRow(row, rowIdx, colHeaders); }) }
      </tbody>
    );
  }

  renderTableRow(row, rowIdx, colHeaders) {
    let rowRenderer = this.props.rowRenderer? this.props.rowRenderer: this.renderDefaultRowItemRenderer;
    let rowClickable = this.isRowClickable;

    return (
      <tr key={'cdt-row-' + rowIdx}
          className={'cdt-table-row cdt-row-' + rowIdx + ((rowIdx % 2 === 0)? ' cdt-striped-even': ' cdt-striped-odd') + (rowClickable? ' clickable': '')}
          onClick={() => this._onRowClicked(row)}>
        { rowRenderer(row, rowIdx, colHeaders) }
      </tr>
    );
  }

  renderDefaultRowItemRenderer(row, rowIdx, colHeaders) {
    return (
      <React.Fragment>
        { _.map(colHeaders, (col, colIdx) => {
            let rowVal = _.get(row, col.field);
            if (col.formatter) {
              if (_.isFunction(col.formatter)) {
                rowVal = col.formatter(rowVal, row, rowIdx);
              } else if (_.isString(col.formatter)) {
                rowVal = _.get(row, col.formatter, rowVal);
              }
            }
            return (
              <td className={'cdt-table-col cdt-col-' + colIdx} key={'cdt-col-' + colIdx}>
                { rowVal }
              </td>
            );
          })
        }
      </React.Fragment>
    );
  }

  getColumnHeaders() {
    let headers = this.props.headers;

    if (!headers) {
      let firstItem = _.first(this.props.data);
      if (firstItem) {
        headers = _.map(_.keys(firstItem), key => {
          return {
            label: key,
            field: key,
          };
        });
      }
    }

    return headers;
  }
}

export default CustomDataTable;
